import {SelectData} from '../../../../../interfaces/form-action-interfaces'
import {CityData, CityResultInterface} from '../interfaces/city-result.interface'
import {GetAllCity, GetAllCityParam} from '../providers/city.provider'
import {create} from 'zustand'

interface CityState {
  cityLoading: boolean
  cityItems: CityData[]
  citySelectData: SelectData[]
  citySelectDataDonation: SelectData[]
  cityModel?: CityResultInterface
  getCities: (params: GetAllCityParam) => void
  onDelete?: (id: string, params: GetAllCityParam) => void
  reset?: () => void
}

export const useCityStore = create<CityState>((set, get) => ({
  reset: () => {
    set({
      citySelectData: [],
      cityModel: undefined,
      cityItems: [],
      citySelectDataDonation: [],
    })
  },
  cityLoading: false,
  cityItems: [],
  citySelectData: [],
  citySelectDataDonation: [],
  cityModel: undefined,
  getCities: async (params: GetAllCityParam) => {
    set({cityLoading: true, citySelectData: [], citySelectDataDonation: [], cityItems: []})
    const response = await GetAllCity(params)
    if (response?.status) {
      if (response?.data?.items?.length > 0) {
        let transformDatas: SelectData[] = []
        let transformDatasDonation: SelectData[] = []
        for (const item of response.data.items) {
          transformDatas.push({
            label: item.name,
            value: item.id,
          })
          transformDatasDonation.push({
            label: item.name,
            value: item.acronym,
          })
        }
        set({
          citySelectData: transformDatas,
          citySelectDataDonation: transformDatasDonation,
          cityItems: response.data.items,
        })
      } else {
        set({
          citySelectData: [],
          citySelectDataDonation: [],
          cityItems: [],
        })
      }
    } else {
      set({
        citySelectData: [],
        citySelectDataDonation: [],
        cityItems: [],
      })
    }
    set({cityLoading: false})
  },
  onDelete: (id: string, params: GetAllCityParam) => {},
}))
